// @ts-nocheck
import { css } from 'styled-components';
import { breakpoint, pxToRem, breakpointsMap } from '@fil-react-mixins/styled';
export const getGutterStyles = (gutters, attrs, { isPadding = false, addWidth = false, addHeight = false } = {}) => {
    return Object.keys(gutters).map((key) => {
        let value = parseFloat(gutters[key].value);
        value = isPadding ? value : -value;
        return css `
      ${breakpoint(key, css `
          ${attrs.map((attr) => `${attr}: ${pxToRem(value / 2)};`)}
          ${addWidth ? `width: calc(100% - ${pxToRem(value)});` : ''}
          ${addHeight ? `height: calc(100% - ${pxToRem(value)});` : ''}
        `)}
    `;
    });
};
export const gridMargin = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['margin-left', 'margin-right']);
}}
`;
export const gridMarginY = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['margin-top', 'margin-bottom']);
}}
`;
export const cellPadding = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['padding-left', 'padding-right'], { isPadding: true });
}}
`;
export const cellPaddingY = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['padding-top', 'padding-bottom'], { isPadding: true });
}}
`;
export const cellMargin = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['margin-left', 'margin-right'], {
        isPadding: true,
        addWidth: true,
    });
}}
`;
export const cellMarginY = css `
  ${(props) => {
    const { gutters } = props.theme.size.grid;
    return getGutterStyles(gutters, ['margin-top', 'margin-bottom'], {
        isPadding: true,
        addHeight: true,
    });
}}
`;
export const sizes = ['sm', 'md', 'lg', 'xlg', 'xxlg'];
export const cellStyles = (props, isVertical = false) => {
    const styleAttr = isVertical ? 'height' : 'width';
    const { columns } = props.theme.grid;
    const { gutters } = props.theme.size.grid;
    let initialSize = null;
    return css `
    ${sizes.map((size) => {
        let styles = '';
        // take size from lower breakpoint is not defined
        const currentSize = props[size] || initialSize;
        initialSize = currentSize;
        if (currentSize) {
            switch (currentSize) {
                case 'auto':
                    styles = css `
              flex: 1 1 0px;
              width: auto;
            `;
                    break;
                case 'shrink':
                    styles = css `
              width: auto;
            `;
                    break;
                default:
                    styles = `
           ${styleAttr}: ${(parseFloat(currentSize) * 100) / columns}%;
          .grid-margin& {
            ${styleAttr}: calc(
              ${(parseFloat(currentSize) * 100) / columns}% -
                ${pxToRem(parseFloat(gutters[breakpointsMap[size]].value))}
            );
          }
        `;
            }
        }
        return styles ? breakpoint(size, styles) : '';
    })}
  `;
};
export const offsetStyles = (props, offset, type = 'left') => {
    const styleAttr = type === 'left' ? 'margin-left' : 'margin-right';
    const { columns } = props.theme.grid;
    const { gutters } = props.theme.size.grid;
    return css `
    ${sizes.map((size) => {
        let styles = '';
        if (offset && offset[size]) {
            styles = css `
          ${styleAttr}: ${(parseFloat([offset[size]]) * 100) / columns}%;
          .grid-margin && {
            ${styleAttr}: calc(
              ${(offset[size] * 100) / columns}% +
              ${pxToRem(parseFloat(gutters[breakpointsMap[size]].value) / 2)}
            );
        `;
        }
        return styles ? breakpoint(size, styles) : '';
    })}
  `;
};
